import styled from 'styled-components';

const JourneyCard = styled.div`
  position: relative;
  box-shadow: 0px 4px 7px 2px rgba(0,0,0,0.2);
  outline: none;
  border-top: 4px ${(props) =>
    props.borderColor ? props.borderColor : '#6acbe5'} solid;
  border-radius: .3em;
  justify-content: center;
  color: inherit;
  padding: 1em;
  background: #fff;
  transition: all .125s ease-in-out;
  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.minWidth && `min-width: ${props.minWidth};`}
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth};`}
  ${(props) => props.height && `height: ${props.height};`}
  ${(props) => props.minHeight && `min-height: ${props.minHeight};`}

  @media (min-width: 735px) {
    flex: 0 1 47%;
  }

  @media (max-width: 735px) {
    margin: .5em 0;
    flex: 100%;
  }
`;

export default JourneyCard;
